// extracted by mini-css-extract-plugin
module.exports = {"spacer":"token_spacer__FGgFD","submitButton":"token_submitButton__gVV6u","captionSessions":"token_captionSessions__YC7M9","captionTerms":"token_captionTerms__NXljF"};